/* ═══════════════════════════════════════════════════════════════
 * usePrivacyTheme.ts
 *
 * Thin hook over `PrivacyThemeContext`. Kept in its own file so
 * components can `import { usePrivacyTheme }` without dragging
 * the provider implementation into their chunk.
 * ═══════════════════════════════════════════════════════════════ */

import { useContext } from 'react';
import { PrivacyThemeContext, type PrivacyThemeContextValue } from './PrivacyThemeContext';

/**
 * Read the active Privacy Suite theme. Always returns a value —
 * if no provider is mounted, the context's default (classic
 * theme + no-op setter) is returned.
 */
export function usePrivacyTheme(): PrivacyThemeContextValue {
	return useContext(PrivacyThemeContext);
}
